import type { VennColors } from 'venn-ui-kit';

const ColorScheme: VennColors = {
  Primary: {
    Main: '#4BB3FD',
    Dark: '#0277CA',
    Light: 'rgba(75, 179, 253, 0.15)',
    Medium: '#CEEBFF',
  },
  PaleTeal: '#94BEC3',
  WhiteGrey: '#F7F7F7',
  PaleGrey: '#F1F1F2',
  LightGrey: '#B2B2B2',
  LightGrey2: '#E6E6E6',
  Grey: '#D8D8D8',
  MidGrey1: '#BBBDBF',
  MidGrey2: '#999999',
  HintGrey: '#767676',
  DarkGrey: '#666666',
  DarkGrey2: '#242A2F',
  HoverGrey: '#F3F1F1',
  Black: '#10161B',
  TransparentBlack: 'rgba(16, 22, 27, 0.9)',
  White: '#FFFFFF',
  Orange: '#F87E3D',
  HighlightDark: '#59A22C',
  HighlightDeepDark: '#5E00EB',
  HighlightLight: '#ABE18A',
  HighlightLightBackground: '#ECDEFF',
  HighlightBackground: '#302683',
  HighlightPaleBackground: '#F7F1FF',
  Alert: '#DE9F9B',
  Error: '#B73A3A',
  Warning: '#FFAB00',
  PeerGroupCarouselColor: '#11696F',

  Gold: '#7C7026',
  PaleGold: '#A08D14',
  Green: '#008854',
  PaleBlue: '#189ACD',
  DarkBlue: '#0072AF',
  DeepDarkBlue: '#006499',
  Pink: '#AE5A88',

  DataLibraryColor: {
    Warning: '#FFF0D9',
  },

  Optimization: {
    Positive: '#008854', // Green
    Negative: '#B73A3A', // Error
  },

  DEPRECATED_DataBarColor: {
    LightGold: '#9E9459',
    LightPaleGold: '#CBBC5B',
    LightPaleBlue: '#6ED6FF',
    LightPink: '#DE9BC0',
    LightDarkBlue: '#3396C7',
  },

  DataBarColor: {
    LightGold: '#9E9459',
    LightPaleBlue: '#6ED6FF',
    LightDarkBlue: '#3396C7',
  },

  DEPRECATED_DataLineColor: {
    Gold: '#867A30',
    PaleGold: '#BEAB32',
    Green: '#00B072',
    PaleBlue: '#4ACCFF',
    DarkBlue: '#007CB9',
    Pink: '#D682B0',
    DeepGreen: '#00897B',
  },

  DataLineColor: {
    Gold: '#867A30',
    PaleGold: '#BEAB32',
    Yellow: '#EAEA06',
    Green: '#00B072',
    PaleBlue: '#4ACCFF',
    DarkBlue: '#007CB9',
    Pink: '#D682B0',
    DeepGreen: '#00897B',
  },

  HoldingsColor: {
    SectorColor: {
      Cyclical: '#33C08F',
      Defensive: '#6ED6FF',
      Sensitive: '#0072AF',
      'Cash And Equivalents': '#008854',
      Corporate: '#EFEF38',
      Derivative: '#DE9BC0',
      Government: '#9E9459',
      Municipal: '#CBBC5B',
      Securitized: '#6D4C5E',
      Unknown: '#BBBDBF',
    },
    AssetColor: {
      'US Stock': '#9E9459',
      'Non-US Stock': '#6ED6FF',
      'US Fixed Income': '#DBD08C',
      'Non-US Fixed Income': '#B7EBFF',
      Preferred: '#FBFBCD',
      Convertible: '#F2F26A',
      Cash: '#008854',
      Other: '#BBBDBF',
      Unknown: '#BBBDBF',
    },
  },

  PeerGroupColor: {
    GradientHigh: '#60C1B4',
    GradientLow: '#D6EDEA',
  },

  CashFlowColor: {
    Historical: '#867A30',
    Projected: '#00897B',
    Typical: '#007CB9',
  },

  StudioSubjectColor: {
    A1: '#CE7322',
    A2: '#0EC5B4',
    A3: '#4637BC',
    A4: '#E2DA1A',
    A5: '#EE71B4',
    A6: '#0EA4FC',
    A7: '#CA481E',
    A8: '#0EC479',
    A9: '#D95B78',
  },

  DEPRECATED_DivergingColor: {
    A5: '#4E2508',
    A4: '#8F5017',
    A3: '#B7793A',
    A2: '#DCB887',
    A1: '#EEDDC7',
    MID: '#F5F5F5',
    B1: '#CAE4E6',
    B2: '#8CC8CC',
    B3: '#3E9397',
    B4: '#11696F',
    B5: '#003638',
  },

  DivergingColor: {
    A5: '#4E2508',
    A4: '#8F5017',
    A3: '#B7793A',
    A2: '#DCB887',
    A1: '#EEDDC7',
    MID: '#F5F5F5',
    B1: '#D3E6CA',
    B2: '#A1CC8C',
    B3: '#5C973E',
    B4: '#306F11',
    B5: '#133800',
  },

  NavigationBarColor: {
    Active: '#2F3942',
    ActiveBackground: '#242A2F',
    ActiveLighter: '#505A63',
    ShimmerBackground: '#505A63',
    InactiveBackground: '#2F3942',
    UpsellInactiveBackground: '#211249',
    UpsellActiveLighter: '#3B0B8D',
    UpsellActiveBackground: '#421595',
  },

  UNSAFE: {
    LightBlue: '#B7E3F5',
    Separator: '#E2E2E2',
    Silver: '#D4D8DC',
    Azure: '#2196F3',
    Steel: '#76848F',
    Red: '#B82A2B',
  },

  GreyScale: {
    Grey10: '#F5F7FA',
    Grey20: '#EBEFF5',
    Grey30: '#DDE3ED',
    Grey40: '#C8D1E0',
    Grey50: '#AFBACC',
    Grey60: '#8E99AB',
    Grey70: '#707A8A',
    Grey80: '#58606E',
    Grey90: '#434A54',
    Grey100: '#333840',
  },
};

export default ColorScheme;
